import BulkUploadUserManual from "components/machineList/bulkUpload/BulkUploadUserManual";
import React from "react";

const DefaultLayout = () => {
  return (
    <div className="deaflut-layout">
      <BulkUploadUserManual />
    </div>
  );
};

export default DefaultLayout;
